import type { FieldSortCriterion } from '../utils/tableSort';

type SortableTableHeaderProps = {
  label: string;
  fieldName: string;
  sort: FieldSortCriterion;
  onSort: (fieldName: string) => void;
  align?: 'left' | 'center' | 'right';
  testId?: string;
};

export default function SortableTableHeader({
  label,
  fieldName,
  sort,
  onSort,
  align = 'left',
  testId,
}: SortableTableHeaderProps) {
  const isActive = sort?.fieldName === fieldName;
  const justifyContent = align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'flex-start';

  return (
    <th aria-sort={isActive ? (sort.isAscending ? 'ascending' : 'descending') : 'none'} data-testid={testId ? `${testId}-${fieldName}` : undefined} style={{ padding: 0 }}>
      <button
        type="button"
        onClick={() => onSort(fieldName)}
        title={`Sort by ${label}`}
        data-testid={testId ? `${testId}-${fieldName}-button` : undefined}
        data-selected={isActive}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          font: 'inherit',
          fontWeight: 'inherit',
          padding: '12px 10px',
          textAlign: align,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent,
          gap: 4,
        }}
      >
        {label}
        {isActive && <span aria-hidden="true">{sort.isAscending ? '\u2191' : '\u2193'}</span>}
      </button>
    </th>
  );
}
